/* ============================================================
   SilkyLock — mt-scripts.js
   Un único listener DOMContentLoaded. Cada init* comprueba que
   su elemento exista antes de hacer nada.
   ============================================================ */

(function () {
  'use strict';

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveal al hacer scroll (stagger vía --mt-delay) ---------- */
  function initReveal() {
    var items = document.querySelectorAll('.mt-reveal');
    if (!items.length) return;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.classList.add('mt-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('mt-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
    );

    items.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ---------- Cifras animadas (count-up) ---------- */
  function initContadores() {
    var contadores = document.querySelectorAll('.mt-contador[data-target]');
    if (!contadores.length) return;

    function animar(el) {
      var target = parseFloat(el.getAttribute('data-target')) || 0;
      var decimals = el.getAttribute('data-decimals') ? parseInt(el.getAttribute('data-decimals'), 10) : 0;
      if (prefersReducedMotion) {
        el.textContent = target.toFixed(decimals);
        return;
      }
      var duration = 1400;
      var start = null;

      function paso(ts) {
        if (start === null) start = ts;
        var progreso = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progreso, 3);
        var valor = target * eased;
        el.textContent = valor.toFixed(decimals);
        if (progreso < 1) {
          window.requestAnimationFrame(paso);
        } else {
          el.textContent = target.toFixed(decimals);
        }
      }
      window.requestAnimationFrame(paso);
    }

    if (!('IntersectionObserver' in window)) {
      contadores.forEach(animar);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animar(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );

    contadores.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ---------- Galería de producto: imagen principal + miniaturas ---------- */
  function initGaleria() {
    var galerias = document.querySelectorAll('[data-mt-galeria]');
    if (!galerias.length) return;

    galerias.forEach(function (galeria) {
      var principal = galeria.querySelector('[data-mt-galeria-principal]');
      var thumbs = galeria.querySelectorAll('[data-mt-galeria-thumb]');
      if (!principal || !thumbs.length) return;

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var full = thumb.getAttribute('data-full');
          var alt = thumb.getAttribute('data-alt') || '';
          if (!full) return;
          principal.src = full;
          principal.alt = alt;
          thumbs.forEach(function (t) {
            t.classList.remove('mt-thumb-activo');
          });
          thumb.classList.add('mt-thumb-activo');
        });
      });
    });
  }

  /* ---------- Comparador antes/después con deslizador ---------- */
  function initComparador() {
    var comparadores = document.querySelectorAll('[data-mt-comparador]');
    if (!comparadores.length) return;

    comparadores.forEach(function (comparador) {
      var after = comparador.querySelector('[data-mt-comparador-after]');
      var handle = comparador.querySelector('[data-mt-comparador-handle]');
      if (!after || !handle) return;

      var arrastrando = false;

      function fijarPosicion(clientX) {
        var rect = comparador.getBoundingClientRect();
        var x = Math.min(Math.max(clientX - rect.left, 0), rect.width);
        var porcentaje = (x / rect.width) * 100;
        after.style.clipPath = 'inset(0 ' + (100 - porcentaje) + '% 0 0)';
        handle.style.left = porcentaje + '%';
      }

      function onMove(e) {
        if (!arrastrando) return;
        var clientX = e.touches ? e.touches[0].clientX : e.clientX;
        fijarPosicion(clientX);
      }

      handle.addEventListener('pointerdown', function (e) {
        arrastrando = true;
        handle.setPointerCapture && handle.setPointerCapture(e.pointerId);
      });
      window.addEventListener('pointerup', function () {
        arrastrando = false;
      });
      comparador.addEventListener('pointermove', onMove);
      comparador.addEventListener('click', function (e) {
        fijarPosicion(e.clientX);
      });
    });
  }

  /* ---------- Inclinación sutil de tarjetas al pasar el cursor ---------- */
  function initTiltCards() {
    if (prefersReducedMotion) return;
    var cards = document.querySelectorAll('[data-mt-tilt]');
    if (!cards.length) return;

    cards.forEach(function (card) {
      card.addEventListener('mousemove', function (e) {
        var rect = card.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        card.style.transform = 'perspective(800px) rotateX(' + (y * -6) + 'deg) rotateY(' + (x * 6) + 'deg)';
      });
      card.addEventListener('mouseleave', function () {
        card.style.transform = '';
      });
    });
  }

  /* ---------- FAQ: acordeón (una pregunta abierta a la vez) ---------- */
  function initFaq() {
    var listas = document.querySelectorAll('[data-mt-faq]');
    if (!listas.length) return;

    listas.forEach(function (lista) {
      var items = lista.querySelectorAll('.mt-faq__item');

      items.forEach(function (item) {
        var toggle = item.querySelector('[data-mt-faq-toggle]');
        if (!toggle) return;

        toggle.addEventListener('click', function () {
          var abierto = item.classList.contains('mt-faq__item--abierto');

          items.forEach(function (otro) {
            otro.classList.remove('mt-faq__item--abierto');
            var otroToggle = otro.querySelector('[data-mt-faq-toggle]');
            if (otroToggle) otroToggle.setAttribute('aria-expanded', 'false');
          });

          if (!abierto) {
            item.classList.add('mt-faq__item--abierto');
            toggle.setAttribute('aria-expanded', 'true');
          }
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initContadores();
    initGaleria();
    initComparador();
    initTiltCards();
    initFaq();
  });
})();
